import React from 'react';
import { Helmet } from 'react-helmet-async';

// Canonical production origin (www is the primary domain; the apex redirects to
// it). If this changes, update public/index.html, robots.txt and sitemap.xml too.
export const SITE_URL = 'https://www.sredzkalzs.pl';
const BASE = 'Średzka LZS';
const DEFAULT_DESC =
    'Średzka LZS — rozgrywki piłkarskie LZS w powiecie średzkim (Środa Wielkopolska): tabela ligowa, puchar, terminarz, wyniki, strzelcy i kartki.';

/**
 * Per-route SEO tags: unique title, description, canonical URL and Open Graph.
 * Rendered once from AppShell based on the current route.
 */
const Seo = ({ title, description, path = '/' }) => {
    const fullTitle = title ? `${title} — ${BASE}` : `${BASE} — liga, puchar, terminarz i wyniki`;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE_URL}${path === '/' ? '/' : path}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
        </Helmet>
    );
};

export default Seo;
